<template>
    <div>
        <div :class="[previous!=true ? '':'bgray-200 p-3 gray-600 rounded', 'mb-5']">

            <div v-if="headers">
                <div :class="[ sub_name !== '' ? 'fw-500 f-110 border-bottom border-color-gray-300 mb-2' : '', '' ]">
                    <span v-if="sub_data_header.required && sub_data_header.required==true">*</span> {{ showTranslation(sub_name, sub_name_e, sub_name_c) || sub_name }}
                </div>
                <div :class="[ sub_description !== '' ? 'mb-3': '', 'mb-1']">
                    <div v-if="is_indicate_description" class="mr-1 fw-500 d-inline px-0"> {{ showTranslation(sub_description, sub_description_e, sub_description_c) || sub_description }} </div>
                    <span v-for="item in tags" :key="item.id">
                        <span v-if="item !== ''" class="ml-2 f-80 gray-500"> {{ item }} </span>
                    </span>
                    <span v-if="!isFieldEmpty(sub_info)" class="ml-2">
                        <b-button :id="`i-${sub_code}`"
                            class="p-0"
                            variant="icon"
                            size="lg"
                            :title="button_title"
                            v-b-tooltip.hover
                            @click="toggleVisible"
                            >
                            <fa icon="info-circle"></fa>
                        </b-button>
                    </span>
                    <span v-if="sub_priority != ''"><b-badge :variant="badge_var" class="mx-2">{{ sub_priority }}</b-badge></span>
                    <b-button v-if="previous_sub.sub_code!=undefined && previous!=true" v-b-toggle="previous_sub.sub_code" size="sm" variant="icon" class="ml-2" v-b-tooltip.hover title="지난해 답변 확인하기"><fa icon="history"></fa></b-button>

                    <!-- sub_info 정보 -->
                    <template v-if="!isFieldEmpty(sub_info)">
                        <div v-show="is_visible" :id="`sub_info-${sub_code}`"
                            class="mt-2 mb-3 px-1 blue f-90"
                            >
                            <fa icon="info-circle" class="mr-1"></fa>
                            <span v-html="showTranslation(sub_info, sub_info_e, sub_info_c) || sub_info"></span>
                        </div>
                    </template>

                    <!-- sub_condition -->
                    <div v-if="is_sub_condition_activated==true" :id="`sub_condition-${sub_code}`" class="my-2 py-2">
                        <b-form-checkbox :disabled="is_locked || is_disabled_by_parent" v-model="sub_condition.value" @change="radioSave"> {{ showTranslation(sub_condition.text, sub_condition.text_e, sub_condition.text_c) || sub_condition.text }} </b-form-checkbox>
                    </div>
                </div>
            </div>

            <b-overlay :show="is_visible_by_pipeline==false" rounded="sm" opacity="0.6" bg-color="#c8c8c8">

                <!-- Priority 유형 Sub Component-->
                <div v-if="sub_data_contents.structure && sub_data_contents.structure.length !=0" class="mb-4">
                    <div v-for="(item, idx) in sub_data_contents.structure" :key="item.id">
                    <b-row no-gutters v-if="!item.is_seperator || item.is_sperator != true" class="w-100 py-2 border-bottom border-color-gray-300 d-flex align-items-center">
                        <b-col class="col-8 col-sm-9 col-md-8 mr-4"> {{ showTranslation(item.text, item.text_ea, item.text_ca) || item.text }} 
                        </b-col>
                        <b-col>
                            순위: <b-dropdown variant="blue-border" :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" :text="sub_data_contents.result[idx]">
                                <b-dropdown-item v-for="(number_item, index) in sub_data_contents.structure" :key="number_item.id" @click="prioritySet(idx, index+1)">{{ index + 1 }}</b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>
                    </div>
                </div>
                <div v-else>
                    <b-card v-if="sub_data_header.mode=='dynamic'">이전 질문에 답변을 하여야 항목이 표시됩니다. </b-card>
                </div>

                <!-- file 저장 --> 
                <template v-if="sub_data_header.has_attachment">
                    <df-attached-file-url
                        class="mt-3"
                        :sub_id="sub_id"
                        :sub_code="sub_code"
                        :sub_init_id="sub_init_id"
                        :company_id="company_id"
                        :company_name="company_name"
                        :campaign_id="campaign_id"
                        :disabled="is_disabled_attached"
                        :audit_mode="audit_mode"
                        :previous="previous"
                        :has_attachment="sub_data_header.has_attachment"
                        :label="label"
                        :key="is_loaded"
                        >
                    </df-attached-file-url>
                </template>

                <div v-if="previous != true" :class="validation_style" @click="retrySave" class="mt-2">
                    <fa v-if="validation_icon !=''" :icon="validation_icon"></fa> {{ validation_comment }}
                </div>

                <b-button v-if="this.save_state!='saved' && this.save_state!='resaved'" @click="handleSave" variant="red">설정한 순위를 저장하여 주십시오.</b-button>
                <b-button v-else @click="handleSave" variant="blue">변경사항 저장</b-button>


                <!-- Child Component -->
                <sub-component v-for="(item, index) in child_subs"
                    :key="item.id"
                    :is_final_sub_component="index == child_subs.length -1 ? true : false"
                    :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" 
                    :sub_type="item.sub_type" 
                    :item="item" 
                    :audit_mode="audit_mode" 
                    :is_disabled_by_parent="is_disabled_by_parent">
                </sub-component>
                    
                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <div class="text-center ">
                        해당사항 없음 <b-button variant="icon" v-b-tooltip.hover :title="pipeline_title"><fa icon="info-circle"></fa></b-button>
                    </div>
                </template>
            </b-overlay>
        </div>

        <!-- previous component -->
        <b-collapse v-if="print_mode!=true" :id="previous_sub.sub_code">
            <sub-component :disabled="true" v-if="previous_sub.sub_code != undefined && previous != true" :is_disabled_by_parent="true" :sub_type="previous_sub.sub_type" :item="previous_sub" :previous="true"></sub-component>
        </b-collapse>
    </div>
</template>


<script>
import { SubComponentMixin } from '@core_mixins/SubComponentMixin'

export default {
    name: 'df-priority',
    mixins: [SubComponentMixin],
    data () {
        return {}
    },
    watch: {
        is_loaded:{
            immediate: true, 
            handler(newVal){
                if(newVal==true){    
                    this.initiateStructure()
                }
            }
        }
    },
    created () {},
    methods:{
        async handleSave () {
            if (this.sub_data_header.duplicated === false) {
                for (let i = 0; i < this.sub_data_contents.result.length ; i++) {
                    for (let j = i + 1; j < this.sub_data_contents.result.length; j++) {
                        if (this.sub_data_contents.result[i] === this.sub_data_contents.result[j]) {
                            this.validation_style = 'ih-validation-saving'
                            this.validation_comment = '순위 중복이 존재하여 저장할 수 없습니다.'
                            return false
                        }
                    }
                }
            }
            
            await this.dbSave()
        },
        prioritySet(idx, number){
            //idx:
            this.$set(this.sub_data_contents.result, idx, number.toString())
        },
        async initiateStructure () {
            try {
                if(this.sub_data_header.mode === 'dynamic') {
                    this.sub_data_contents.structure = []
                    const response = await this.$axios.get('/subs', {
                        params: {
                            question_code: this.question_code,
                            campaign_id: this.campaign_id,
                            company_id: this.company_id,
                            sub_codes: [this.sub_data_header.sub_code]
                        }
                    })

                    let new_contents = response.data.sub_data_contents

                    if (this.sub_data_header.answer_only === true) {
                        let temp_structure = []
                        new_contents.result.forEach(item => {
                            let idx = new_contents.structure.findIndex(x => x.value == item)
                            if (idx > -1) {
                                temp_structure.push(new_contents.structure[idx])
                            }
                        })

                        this.$set(this.sub_data_contents, 'structure',temp_structure)
                        this.$forceUpdate()
                    } else {
                        let temp_structure = []
                        new_contents.structure.forEach( item => {
                            if(item.is_sperator && item.is_sperator == true) { }
                            else{
                                this.temp_structure.push(item)
                            }
                        })
                        this.$set(this.sub_data_contents, 'structure', temp_structure)
                        this.$forceUpdate()
                    }
                }
            } catch (error) {
                console.log(error)
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.common_401_error_handling()
                    }
                }
            }
            
        }
    }
}


</script>

<style>

</style>
